import useMoveBookToTrash from "api/BookResource/useMoveBookToTrash";
import { ConfirmPopup } from "primereact/confirmpopup";
import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FiTrash2 } from "react-icons/fi";

const DeleteBook = ({ elementId, bookId }) => {
	const [visible, setVisible] = React.useState(false);

	const { mutateAsync, isLoading: bookIsDeleting } = useMoveBookToTrash(bookId);

	const accept = async () => {
		await mutateAsync();
	};

	return (
		<>
			<button
				type="button"
				className="action-btn w-9 h-9 rounded-xl flex items-center justify-center bg-red-50 text-red-500 hover:bg-red-500 hover:text-white transition-all duration-300 border border-red-100 hover:border-red-500 shadow-sm hover:shadow-md active:scale-90"
				onClick={() => setVisible(true)}
				id={elementId}
				data-pr-tooltip="Delete Book"
			>
				{bookIsDeleting ? (
					<AiOutlineLoading3Quarters
						size={14}
						className="animate-spin"
					/>
				) : (
					<FiTrash2 size={14} />
				)}
			</button>

			<ConfirmPopup
				target={document.getElementById(elementId)}
				className="font-sans text-sm items-start"
				visible={visible}
				onHide={() => setVisible(false)}
				message={
					<div
						className="p-4 rounded-md space-y-2"
						style={{ maxWidth: 350 }}
					>
						<p>
							Are you sure you want to permanently delete this book? Books are
							in active use (through reading, purchase, or subscription) will
							not be deleted
						</p>
						<p className="text-red-600 font-cera-black">
							Note this action is irreversible
						</p>
					</div>
				}
				// icon="pi pi-exclamation-triangle"
				accept={accept}
			/>
		</>
	);
};

export default DeleteBook;
